<template>
  <div
    class="offers">
    <Groups
      id="offerstable-container"
      ref="groups"
      :can_expand="can_expand"
      class="offers-groups"
      :filter-empty-by="gr => gr.count || !active_infinity"
      filter_empty
      :grouped-by_types="group_types"
      :grouped_by.sync="grouped_by_sync"
      :groups.sync="bid_groups"
      items-key="items"
      :with_title=" with_header"
      @update:expanded="updExpanded">
      <template
        #title="{ group }">
        <span>
          <slot
            :group="group"
            name="title">
            <sBadge
              class="mr-1"
              color="var(--v-secondary__green_chosen-base)"
              :content="group.selected.length"
              data-qa="offers-groups-badge"
              offset-x="0"
              offset-y="10"
              overlap
              text-color="var(--black-color)"
              :value="!without_select && group.selected && group.selected.length">
              <span class="bold font-size-16">{{ group.title }}</span>
            </sBadge>
          </slot>
          <slot
            name="subtitle">
            <span
              v-if="group.winners || group.subtitle"
              class="secondary__green_not_active--text"
              data-qa="offers-summ">
              ({{ getGroupSubTitle(group) }})
            </span>
          </slot>
        </span>
      </template>
      <template #content="{ group }">
        <component
          v-if="isGroupLogic"
          :is="grouped_by_sync.component"
          :key="group.unigueKey"
          ref="offers_table"
          :contranct-props="contranctProps"
          :critery-card="criteryCard"
          :currencies="currencies"
          :group="group"
          :group-type="grouped_by_sync.type"
          :mode="mode"
          :only_review="only_review"
          :selecting="selecting"
          :tender="tender"
          :without_select="without_select"/>
        <OffersTable
          v-else
          :key="group.id"
          ref="offers_table"
          :change_winner_mode.sync="change_winner_mode"
          :contranct-props="contranctProps"
          :critery-card="criteryCard"
          :currencies="currencies"
          :custom-sort="(...args) => customSortSlice(group, args)"
          :format-headers="group.formatHeaders"
          :group="group"
          :hide_foreign="hide_foreign"
          infinity_selector="#offerstable-container"
          :items.sync="group.items"
          :mode="mode"
          :only_review="only_review"
          :selecting="selecting"
          :show_selected_quantity="group.winners"
          :tab="tab"
          :tender="tender"
          :toggle-select-all="(args, sel) => toggleSelectAll(group, args, sel)"
          :without_select="without_select"/>
      </template>
    </Groups>
    <InfinityUpdater
      ref="infinity"
      :action="infinityLoad"
      :active="active_infinity && infinity"
      call-on-mount
      :pixels_when_update="200"
      :selector="infinity_selector"/>
  </div>
</template>

<script>
import Groups from 'components/common/blocks/groups/Groups.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'
import OffersTable from 'components/tenders/tender page/offersGroups/OffersTable.vue'
import OffersGroupTable from 'components/tenders/tender page/offersGroups/OffersGroupTable.vue'

import { mapGetters } from 'vuex'

/* eslint-disable vue/prop-name-casing */

import { modalMixin, snackbarMixin, tenderMixin } from 'mixins'
export default {
  name: 'offersGroups',
  mixins: [modalMixin, snackbarMixin, tenderMixin],
  data() {
    return {
      expanded: null,
      count: 0,
      sliced_groups: [],
      currencies: [],
    }
  },
  props: {
    /*
      тільки перегляд - без редагування і переходу
    */
    only_review: {
      type: Boolean,
      default: false
    },
    tender: Object,
    bid_groups: Array,
    bids: Array,
    criteryCard: Object,
    change_winner_mode: Boolean,
    tab: [Number, Object],
    show_selected_quantity: Boolean,
    without_select: Boolean,
    with_header: Boolean,
    can_expand: Boolean,
    /** включаем подгрузку при скроле. При нескольких группах глючит */
    infinity: {
      type: Boolean,
      default: true
    },
    /** селектор компонента для подгрузки при скроле */
    infinity_selector: {
      type: String,
      default: '#content-container'
    },
    /** функція вибору  */
    select: {
      type: Function
    },
    /**
     * групування за
     */
    grouped_by: {
      type: Object
    },
    /**
     * типи групування
     * використовується тільки з grouped_by
     */
    group_types: {
      type: Array
    },
    /**
     * приховати чіпс "зовнішній"
     */
    hide_foreign: {
      type: Boolean
    },
    /**
     * Место где используется таблица.
     * На текущий момент, нужно только для правильной обработки результата запроса по изменению цены
     */
    mode: {
      type: String
    },
    contranctProps: {
      type: Object
    },
  },
  created() {
    this.expanded = this.$_.cloneDeep(this.bid_groups)
  },
  computed: {
    ...mapGetters({
      $_tendersSettings: 'getTendersSettings',
    }),
    isGroupLogic() {
      return this.grouped_by_sync?.isGroup
    },
    per_page() {
      return Math.round(document.documentElement.clientHeight / 55)
    },
    active_infinity() {
      return this.bids.length > this.count
    },
    grouped_by_sync: {
      get() {
        return this.grouped_by
      },
      set(value) {
        this.$emit('update:grouped_by', value)
      }
    }
  },
  methods: {
    getGroupSubTitle(group) {
      let currency = this.tender.currency ? this.tender.currency.title : this.tender.tenderCurrency
      return  group.subtitle ? group.subtitle : `${this.$t('Suppliers.Summ')} ${this.formSum(this.getOffersSum(group)) } ${currency}`
    },
    updExpanded(expanded, group, push) {
      if (push) {
        if (this.expanded?.length) {
          this.count += this.per_page
        } else {
          this.count = this.per_page
        }
      } else {
        this.count -= group.count
        if (this.count < this.per_page) {
          this.count = this.per_page
        }
      }
      this.expanded = this.$_.cloneDeep(expanded)
      this.updGroups()
    },
    infinityLoad() {
      if (!this.infinity) {
        this.count = this.bids?.length || 0
      }
      if (this.count < this.bids?.length) {
        this.count = Math.min(this.bids?.length, this.count + this.per_page)
        this.updGroups()
      }
    },
    updGroups() {
      let groups = this.bid_groups
      let count = this.infinity ? this.count : this.bids?.length

      this.$_.forEach(groups, el => {
        if (!this.$_.some(this.expanded, it => it.id == el.id) && count > 0) {
          el.count = 1
        } else if (count <= 0) {
          el.count = 0
        } else {
          el.count = Math.min(el.items.length, count)
          count = count - el.items.length
        }
      })
    },
    /**
     * сортуємо весь список з групи і обрізаємо !!
     *
     * group - об2єкт групи
     * args - масив з  https://vuetifyjs.com/en/api/v-data-table/#props-custom-sort - (items: any[], sortBy: string[], sortDesc: boolean[], locale: string, customSorters?: Record<string, compareFn>) => any[]
     */
    customSortSlice(group , args) {
      let [, sort_by, sort_desc] = args,
        items = group.items.slice(0),
        slice = its =>  this.infinity ? its.slice(0, group.count) : its

      if (sort_by === null || !sort_by.length) { return slice(items) }
      /*
       взяла метод з вьюті
       https://github.com/vuetifyjs/vuetify/search?q=sortItems
       https://github.com/vuetifyjs/vuetify/blob/ca4cbda0877096bab9b65c7af6edb18f316e076b/packages/vuetify/src/util/helpers.ts
      */

      let res =  slice(items.sort((a, b) => {
        for (let i = 0; i < sort_by.length; i++) {
          const sortKey = sort_by[i]

          let sortA = sortKey == 'quantity' ? a.selectedQuantity || a[sortKey] : a[sortKey]
          let sortB = sortKey == 'quantity' ? b.selectedQuantity || b[sortKey] : b[sortKey]

          if (sort_desc[i]) {
            [sortA, sortB] = [sortB, sortA]
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            continue
          }

          // Dates should be compared numerically
          if (sortA instanceof Date && sortB instanceof Date) {
            return sortA.getTime() - sortB.getTime()
          }

          if (typeof sortA == 'number' ) {
            if (sortA !== sortB) {
              return sortA - sortB
            }
            continue
          }
          [sortA, sortB] = [sortA, sortB].map(s => (s || '').toString().toLocaleLowerCase())

          if (sortA !== sortB) {
            return sortA?.localeCompare(sortB)
          }
        }
        return 0
      }))
      return res
    },
    getOffersSum(item) {
      let result =  item.items.reduce((total, bid) => {
        let quantity = bid.selectedQuantity || bid.quantity,
          price = this.tender.currencyOwner ? bid.price : bid.currencyPrice
        return  total += +(quantity * price).toFixed(this.$_tendersSettings.priceRoundingDigit)
      }, 0)
      return result
    },
    selecting(selected, group) {
      let selected_items = []
      group.selected = selected
      this.bid_groups.forEach(group => {
        selected_items.push(...group.selected)
      })
      this.$emit('update:selected', selected_items)
      if (this.select) {
        this.select(selected, group, selected_items)
        return
      }
      if (selected_items.length) {
        selected_items = selected_items.map(el => {
          let it
          this.bid_groups.find(group => {
            it = group.items.find(item =>
              el.unigueKey ? item.unigueKey == el.unigueKey : item.id == el.id
            )
            return it
          })
          return it
        })

        let snackbarName = this.change_winner_mode ? 'change-winner' : 'lot-offers'

        this.$_openSnackbar({
          name: this.isGroupLogic ? 'lot-group-offers' : snackbarName,
          elements: selected_items,
          tender: this.tender,
          criteryCard: this.criteryCard,
          retraining: this.tender.tenderStatus.id == this.statuseKeys.PREQUALIFICATION,
          callback: () => {
            this.tender.bids.forEach(bid => bid.bidDetails.forEach(det => {
              let item = selected_items.find(item => item.id == det.id)
              if (item) {
                Object.keys(det).forEach(key => det[key] = item[key])
              }
            }))
            this.bid_groups.forEach(group => group.selected = [])
            if (Array.isArray(this.$refs.offers_table)) {
              this.$refs.offers_table.forEach(item => item.selected = [])
            } else if (this.$refs.offers_table) {
              this.$refs.offers_table.selected = []
            }
            this.$forceUpdate()
            this.$emit('update:selected', [])
            this.$emit('applyOfferSearch')
            this.$_closeSnackbar()
          }
        })
      } else if (selected_items.length == 0) {
        this.$_closeSnackbar()
      }
    },
    toggleSelectAll(group, arg) {
      return arg.value ? group.items.slice(0) : []
    }
  },
  watch: {
    change_winner_mode(val) {
      if (!val) {
        this.$_closeSnackbar()
      }
    },
    tab(val,) {
      if (val.value != 'offers') {
        this.$_closeSnackbar()
      }
    },
    bid_groups(val, old) {
      if (this.$_.differenceBy(val, old, 'items')?.length) {
        this.expanded = this.$_.cloneDeep(val)
        if (this.infinity) {
          this.count = this.per_page
          this.updGroups()
        }
      }

    },
  },
  components: {
    Groups,
    OffersTable,
    InfinityUpdater,
    OffersGroupTable
  }
}
</script>

<style lang="scss" scoped>
.group-header {
  cursor: pointer;
}
</style>
